const polynomial = `
  polynomial = [-]? monomial ([-+] monomial)* 
  monomial   = term([*] term)* 
  term       = \\d+[*]termbase / termbase[*]\\d+ / termbase / \\d+ / [(] polynomial [)] 
  termbase   = [xy]([^]\\d+)?
`;

export default polynomial;
